import Logo from "./Logo";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL, scrollToId } from "../lib/site";
import { Phone, MessageCircle, MapPin, Building2, Mail } from "lucide-react";

const Footer = () => (
  <footer
    className="border-t border-cream/10 bg-ink py-16 text-cream"
    data-testid="site-footer"
  >
    <div className="mx-auto grid max-w-7xl gap-12 px-5 md:grid-cols-4 md:px-10">
      <div className="flex flex-col items-start gap-5">
        <Logo light />
        <p className="max-w-xs font-sans text-xs font-light leading-relaxed text-sand/60">
          Posa parquet a regola d'arte: dritta, spina italiana, spina francese
          e ungherese. Sopralluogo gratuito, prezzi chiari al metro quadro.
        </p>
      </div>
      <div>
        <p className="mb-5 font-sans text-xs font-light uppercase tracking-[0.4em] text-honey">
          Contatti
        </p>
        <div className="flex flex-col gap-3 font-sans text-sm font-light text-sand/80">
          <a
            href={`tel:${PHONE_TEL}`}
            data-testid="footer-phone-link"
            className="flex items-center gap-2 transition-colors hover:text-honey"
          >
            <Phone size={15} /> {PHONE_DISPLAY}
          </a>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="flex items-center gap-2 transition-colors hover:text-honey"
          >
            <MessageCircle size={15} /> WhatsApp
          </a>
          <a
            href="mailto:Russrl0210@gmail.com"
            data-testid="footer-email-link"
            className="flex items-center gap-2 transition-colors hover:text-honey"
          >
            <Mail size={15} /> Russrl0210@gmail.com
          </a>
          <span className="flex items-center gap-2">
            <MapPin size={15} /> Roma e provincia
          </span>
        </div>
      </div>
      <div>
        <p className="mb-5 font-sans text-xs font-light uppercase tracking-[0.4em] text-honey">
          Il sito
        </p>
        <div className="flex flex-col gap-3 font-sans text-sm font-light text-sand/80">
          {[
            ["prezzi", "Prezzi standard"],
            ["calcolatore", "Calcola il prezzo"],
            ["lavori", "I nostri lavori"],
            ["sopralluogo", "Sopralluogo gratuito"],
          ].map(([id, label]) => (
            <button
              key={id}
              onClick={() => scrollToId(id)}
              data-testid={`footer-link-${id}`}
              className="w-fit transition-colors hover:text-honey"
            >
              {label}
            </button>
          ))}
        </div>
      </div>
      <div>
        <p className="mb-5 font-sans text-xs font-light uppercase tracking-[0.4em] text-honey">
          Dati aziendali
        </p>
        <div className="flex flex-col gap-3 font-sans text-sm font-light text-sand/80" data-testid="footer-company-data">
          <span className="flex items-center gap-2">
            <Building2 size={15} className="shrink-0" /> RUS S.r.l.
          </span>
          <span className="text-sand/70">CF e P.IVA 18478031000</span>
          <span className="flex items-start gap-2">
            <MapPin size={15} className="mt-1 shrink-0" />
            <span>
              Via Maida 89
              <br />
              00132 Roma (RM)
            </span>
          </span>
          <a
            href="mailto:russrl@legalmail.it"
            data-testid="footer-pec-link"
            className="flex items-center gap-2 transition-colors hover:text-honey"
          >
            <Mail size={15} className="shrink-0" /> russrl@legalmail.it
            <span className="text-[10px] uppercase tracking-widest text-sand/50">PEC</span>
          </a>
        </div>
      </div>
    </div>
    <div className="mx-auto mt-14 flex max-w-7xl flex-wrap items-center justify-between gap-3 border-t border-cream/10 px-5 pt-7 font-sans text-[11px] font-light text-sand/45 md:px-10">
      <span>© {new Date().getFullYear()} RUS S.r.l. — P.IVA 18478031000 — Tutti i diritti riservati</span>
      <span className="font-display italic text-sand/55">
        Il parquet, posato a regola d'arte.
      </span>
      <button
        onClick={() => window.dispatchEvent(new Event("open-privacy"))}
        data-testid="footer-privacy-link"
        className="transition-colors hover:text-honey"
      >
        Privacy Policy
      </button>
      <button
        onClick={() => window.dispatchEvent(new Event("reset-cookies"))}
        data-testid="footer-cookies-link"
        className="transition-colors hover:text-honey"
      >
        Gestisci cookie
      </button>
    </div>
  </footer>
);

export default Footer;
